<template>
  <div class="orders">
    <el-row class="order-title">
      <el-col :span="3">
        <span class="h3">{{$t('zhi_zuo_qing_dan')}}</span>
      </el-col>
      <el-col :span="21" class="order-list-filter">
        <el-form label-width="auto" :inline="true" size="mini">
          <el-col :span="6">
            <el-form-item :label="$t('zhi_fu_fang_shi')">
              <el-select :placeholder="$t('qing_xuan_ze_zhi_fu_fang_shi')" v-model="pagination.payStyle"
                         class="order-input-filter"
                         @change="loadOrder">
                <el-option v-for="item in orderPayOption"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('zhi_zuo_lei_xing')">
              <el-select :placeholder="$t('qing_xuan_ze_zhi_zuo_lei_xing')"
                         class="order-input-filter" v-model="pagination.orderType"
                         @change="loadOrder">
                <el-option v-for="item in orderTypeOption"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('zhi_zuo_zhuang_tai')">
              <el-select :placeholder="$t('qing_xuan_ze_zhi_zuo_lei_xing')"
                         class="order-input-filter" v-model="pagination.makeStatus"
                         @change="loadOrder">
                <el-option v-for="item in orderMakeStatusOption"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('tiao_jian_sou_suo')">
              <el-select :placeholder="$t('qing_shu_ru_she_bei_ming_cheng')" class="order-input-filter"
                         prefix-icon="el-icon-search"
                         v-model="pagination.deviceUuid"
                         @change="loadOrder"
                         filterable
                         remote
                         reserve-keyword
                         clearable
                         :remote-method="deviceNameSearch"
                         :loading="loading">
                <el-option
                  v-for="item in devices"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item :label="$t('ding_dan_bian_hao')">
              <el-input :placeholder="$t('qing_shu_ru_ding_dan_bian_hao')" class="order-input-filter" clearable
                        v-model="pagination.orderUuid" @change="loadOrder"
                        prefix-icon="el-icon-search"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item :label="$t('xuan_qu_fen_zu')">

              <el-select :placeholder="$t('qing_xuan_ze_suo_shu_fen_zu')" class="order-input-filter"
                         prefix-icon="el-icon-search"
                         v-model="pagination.departmentUuid"
                         @change="loadOrder"
                         clearable
                         :loading="loading">
                <el-option
                  v-for="item in groups"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.uuid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('zhi_zuo_shi_jian')">
              <el-date-picker
                @change="loadOrder"
                v-model="makeTimeRange"
                type="datetimerange"
                :picker-options="pickerOptions"
                :range-separator="$t('zhi')"
                :start-placeholder="$t('kai_shi_ri_qi')"
                :end-placeholder="$t('jie_shu_ri_qi')">
              </el-date-picker>

            </el-form-item>
          </el-col>
        </el-form>
      </el-col>
    </el-row>

    <div class="order-data-list">
      <el-table :data="orders">
        <el-table-column :label="$t('ding_dan_bian_hao')" prop=""
                         min-width="240">
          <template slot-scope="scope">
            <div class="user-info">
              <p>{{$t('order_number')}}: {{scope.row.orderUuid}}</p>
              <p style="margin-top: 4px">{{$t('pay_number')}}: {{scope.row.traditionUuid}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('she_bei_bian_hao')" align="center" prop="deviceName"
                         min-width="108"></el-table-column>
        <el-table-column min-width="120" :label="$t('yin_pin_ming_chen') +'/'+$t('yin_pin_bei_liang')" align="center"
                         prop="name">
          <template slot-scope="scope">
            <div class="user-info">
                            <span>
                               {{scope.row.name}}/{{filterSize[scope.row.size]}}
                                </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('ding_dan_zhuang_tai')" align="center">
          <template slot-scope="scope">
            <div class="user-info">
                  <span :class="[{ offline: scope.row.status ==0 }, { fault: scope.row.status ==2 },
                          { normal: scope.row.status ==1 }]">
                         <span class="circle"
                               v-show="scope.row.status ==1"></span> {{filterOrderStatus[scope.row.status ]}}
                      </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('zhi_fu_jin_e')" align="center">
          <template slot-scope="scope">
            <span>{{(parseInt(scope.row.money)/ 100).toFixed(2)  }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('zhi_fu_fang_shi')" align="center">
          <template slot-scope="scope">
            <div class="user-info">
                  <span :class="[{ notPay: scope.row.payStyle ==1 }, { aliPay: scope.row.payStyle ==2 },
                          { wechatPay: scope.row.payStyle ==3 }]">
                        {{filterPay[scope.row.payStyle]}}
                      </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('zhi_zuo_lei_xing')" align="center">
          <template slot-scope="scope">
            <div class="user-info">
                  <span :class="[{ testPayMake: scope.row.orderType ==1 }, { notPayMake: scope.row.orderType ==2 },
                          { payMake: scope.row.orderType ==3 }]">
                         {{filterMakeStyle[scope.row.orderType]}}
                      </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('tui_kuan_zhuang_tai')" align="center">
          <template slot-scope="scope">
            <div class="user-info">
                  <span :class="[{ offline: scope.row.payStatus ==0 },
                          { fault: scope.row.payStatus ==1 },
                          { normal: scope.row.payStatus ==2 }]">
                         <span class="circle" v-show="scope.row.payStatus ==1"></span>
                      {{filterReturnStatus[scope.row.payStatus]}}
                      </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('ding_dan_shi_jian')" align="center" min-width="112">
          <template slot-scope="scope">
            <span>{{new Date(scope.row.createdAt * 1000).Format('yyyy-MM-dd hh:mm:ss')}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('cao_zuo')" align="center" width="100" v-if="!$btnCheck('pay_refund')">
          <template slot-scope="scope">
                        <span @click="handleRefund(scope.row, scope.$index)" class="order-edit order"
                              :class="{disable: scope.row.returnStatus ==2 || scope.row.payStatus ==2 }">{{$t('ding_dan_tui_kuan')}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      class="pagination"
      :current-page="pagination.curPage"
      :page-size="pagination.limit"
      layout="total, prev, pager, next, jumper"
      :total="pagination.total">
    </el-pagination>
  </div>

</template>

<script>
  import {orderUnion, orderList} from '@/api/delivery/order/order'
  import {deviceSearch} from '@/api/delivery/device/list'

  import {payWxRefund, payAliRefund} from '@/api/delivery/pay/set'
  import {groupAll} from '@/api/delivery/organization/group'

  export default {
    name: '',
    components: {},
    activated: function () {
      groupAll().then(res => {
        this.groups = res.data || []
      })
      this.loadOrder()
    },
    data: function () {
      return {
        orders: [],
        groups: [],
        pickerOptions: {

          shortcuts: [{
            text: this.$t('jin_tian'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setHours(0, 0, 0, 0)
              end.setHours(23, 59, 59, 0)
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: this.$t('zuo_tian'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              start.setHours(0, 0, 0, 0)
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              end.setHours(23, 59, 59, 0)

              picker.$emit('pick', [start, end]);
            }
          }, {
            text: this.$t('zui_jin_yi_zhou'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: this.$t('zui_jin_yi_yue'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: this.$t('zui_jin_san_yue'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        orderPayOption: [
          {label: this.$t('suo_you_zhi_fu'), value: 0},
          {label: this.$t('wu_zhi_fu'), value: 1},
          {label: this.$t('zhi_fu_bao'), value: 2},
          {label: this.$t('wei_xin_zhi_fu'), value: 3},
          {label: this.$t('su_zhou_nong_hang'), value: 4},
        ],
        orderTypeOption: [
          {label: this.$t('suo_you_ding_dan'), value: 0},
          {label: this.$t('ce_shi_ding_dan'), value: 1},
          {label: this.$t('wu_zhi_fu_ding_dan'), value: 2},
          {label: this.$t('zhi_fu_ding_dan'), value: 3},
        ],
        orderMakeStatusOption: [
          {label: this.$t('all'), value: 0},
          {label: this.$t('make_success'), value: 1},
          {label: this.$t('make_fail'), value: 2},
        ],
        pagination: {
          startAt: 0,
          endAt: 0,
          orderType: 0,
          makeStatus: 0,
          payStyle: 0,
          total: 0,
          deviceUuid: '',
          orderUuid: '',
          current: 0,
          start: 0,
          limit: 10,
        },
        makeTimeRange: [],
        loading: false,
        devices: [],
        filterReturnStatus: [this.$t('chu_shi_zhuang_tai'), this.$t('yi_zhi_fu'), this.$t('yi_tui_kuan')],
        filterOrderStatus: [this.$t('zhi_zuo_zhong'), this.$t('cheng_gong'), this.$t('zhi_zuo_shi_bai')],
        filterSize: [this.$t('xiao_bei'), this.$t('zhong_bei'), this.$t('da_bei')],
        filterPay: ['', this.$t('wu_zhi_fu'), this.$t('zhi_fu_bao'), this.$t('wei_xin_zhi_fu'), this.$t('su_zhou_nong_hang')],
        filterMakeStyle: ['', this.$t('ce_shi_ding_dan'), this.$t('wu_zhi_fu_ding_dan'), this.$t('zhi_fu_ding_dan')],

      }
    },

    methods: {
      handleCurrentChange(value) {
        this.pagination.curPage = value
        this.pagination.start = (value - 1) * this.pagination.limit
        if (this.makeTimeRange.length > 1) {
          this.pagination.startAt = parseInt(this.makeTimeRange[0] / 1000)
          this.pagination.endAt = parseInt(this.makeTimeRange[1] / 1000)
        } else {
          this.pagination.startAt = 0
          this.pagination.endAt = 0
        }

        orderList(this.pagination).then(res => {
          this.orders = res.data || []
        })
      },

      loadOrder() {
        let vue = this
        this.pagination.curPage = 1
        this.pagination.start = 0
        if (this.makeTimeRange.length > 1) {
          this.pagination.startAt = parseInt(this.makeTimeRange[0] / 1000)
          this.pagination.endAt = parseInt(this.makeTimeRange[1] / 1000)
        } else {
          this.pagination.startAt = 0
          this.pagination.endAt = 0
        }
        orderUnion(this.pagination).then(res => {
          vue.orders = res.data.list || []
          vue.pagination.total = parseInt(res.data.total)
        })
      },
      deviceNameSearch(query) {
        if (query !== '') {
          this.loading = true;
          deviceSearch({name: query}).then(res => {
            this.devices = res.data || []
            this.loading = false;
          })
        } else {
          this.devices = [];
        }
      },

      handleEdit(row, index) {
      },

      handleRefund(row, index) {
        this.$confirm('此操作将会退还订单金额, 是否继续?', this.$t('ti_shi'), {
          confirmButtonText: this.$t('que_ding'),
          cancelButtonText: this.$t('qu_xiao'),
          type: 'warning'
        }).then(() => {
          switch (row.payStyle) {
            case 2:
              payAliRefund({
                orderUuid: row.orderUuid,
                deviceUuid: row.deviceUuid,
                fee: parseInt(row.money)
              }).then(() => {
                this.$message.success('退款成功')
                this.orders[index].payStatus = 2
              })
              break;
            case 3:
              payWxRefund({
                orderUuid: row.orderUuid,
                deviceUuid: row.deviceUuid,
                fee: parseInt(row.money)
              }).then(() => {
                this.$message.success('退款成功')
                this.orders[index].payStatus = 2
              })
              break;
          }
        }).catch(() => {

        })

      },
      handleDelete(row, index) {
      },
      handleAreaChange(value) {
        console.log(value)
      }
    },
  }
</script>

<style lang="scss">
  .orders {
    padding: $padding $t-padding;
    display: flex;
    flex-direction: column;

    .order-title {
      .order-input-filter {
        input {
          border: none;
          border-bottom: 1px solid $f_fiv_color;
          font-size: $filter-font-size;
          border-radius: 0;
        }
      }
    }

    .order-data-list {
      margin-top: $padding;
      flex: 1;

      .order-info {
        .order-info-img {
        }

        .order-info-detail {

          p {
            margin-bottom: $padding-5;
          }

          p:first-child {
            font-size: .8rem;
          }
        }
      }

      .el-table {
        thead {
          tr {
            th {
              border-bottom: 1px solid $border_sec_color;
            }
          }
        }

      }

      .el-table--group::after, .el-table--border::after, .el-table::before {
        background-color: transparent;
      }

      .el-table__row:hover {
        background-color: $bg_sec_color;
      }

      .order {
        padding: 0 .3rem;
      }

      .order-edit, .order-delete {
        cursor: pointer;
        display: inline-block;
      }

      .order-edit:hover, .order-delete:hover {
        color: $f_color;
      }

      .order-edit {
        color: $btn_color;
      }

      .order-edit:hover {
      }

      .order-delete {
        color: $btn_sec_color;
      }

      .order-delete:hover {
      }

      .disable {
        cursor: not-allowed;
        color: $f_50_color;
        border: none;
      }

      .disable:hover {
        color: $f_50_color;
        background-color: $bg_six_color;
      }

      .circle {
        border-radius: $small_font_size;
        width: $small_font_size;
        height: $small_font_size;
        display: inline-block;
        margin-right: 5px;
      }

      .wechatPay {
        color: #44b549;
      }

      .aliPay {
        color: #00aaee;
      }

      .testPayMake {
        color: #5AD8A6;
      }

      .notPayMake {
        color: #F6BD16;
      }

      .payMake {
        color: #5B8FF9;
      }

      .offline {
        color: #5B8FF9;

        .circle {
          background-color: #5B8FF9;
        }
      }

      .normal {
        color: #5AD8A6;

        .circle {
          background-color: #5AD8A6;
        }
      }

      .warning {
        color: #F6BD16;

        .circle {
          background-color: #F6BD16;
        }
      }

      .fault {
        color: #E8684A;

        .circle {
          background-color: #E8684A;
        }
      }

    }

    .pagination {
      margin: $padding;
      text-align: right;
    }
  }

</style>
